import { useState } from 'react';
import { CATEGORIES } from '../data/categories';
import { useApp } from '../context/AppContext';
import EmojiPicker from './EmojiPicker';
import styles from './EntryCard.module.css';

function formatDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    weekday: 'short', month: 'short', day: 'numeric',
  });
}

export default function EntryCard({ entry, authorName, ownerUserId }) {
  const { dispatch } = useApp();
  const [pickerFor, setPickerFor] = useState(null);

  return (
    <>
      <article className={styles.card}>
        <header className={styles.header}>
          {authorName && <span className={styles.author}>{authorName}</span>}
          <span className={styles.date}>{formatDate(entry.date)}</span>
        </header>
        <div className={styles.responses}>
          {CATEGORIES.map(cat => {
            const data = entry[cat.key];
            if (!data?.response) return null;

            const interactions = entry.interactions?.[cat.key];
            const reactionCounts = interactions?.reactionCounts || {};
            const reactionEntries = Object.entries(reactionCounts).filter(([, n]) => n > 0);
            const replyCount = interactions?.replyCount || 0;
            const latestReply = interactions?.latestReply || null;
            const hasUnread = interactions?.hasUnread || false;

            return (
              <div
                key={cat.key}
                className={styles.response}
                style={{ '--accent': `var(${cat.accentVar})` }}
                onClick={() => dispatch({
                  type: 'OPEN_DETAIL',
                  detail: {
                    ownerUserId,
                    entryId: entry.id,
                    categoryKey: cat.key,
                    responseText: data.response,
                    entryDate: entry.date,
                    ownerName: authorName,
                    isOwn: true,
                  },
                })}
              >
                <div className={styles.reactionStrip} onClick={e => e.stopPropagation()}>
                  {reactionEntries.map(([emoji, count]) => (
                    <span key={emoji} className={styles.reactionChip}>{emoji} {count}</span>
                  ))}
                  <button
                    className={styles.addReactionBtn}
                    onClick={e => { e.stopPropagation(); setPickerFor(cat.key); }}
                  >
                    +
                  </button>
                </div>
                <span className={styles.catLabel}>{cat.icon} {cat.label}</span>
                <p className={styles.text}>{data.response}</p>
                {latestReply && (
                  <div className={styles.replyPreview}>
                    {hasUnread && <span className={styles.unreadDot} />}
                    <span className={styles.previewText}>
                      "{latestReply.text.length > 60
                        ? latestReply.text.slice(0, 60) + '…'
                        : latestReply.text}"
                      {' '}— {latestReply.authorName} · 💬 {replyCount}
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </article>

      {pickerFor && (
        <EmojiPicker
          ownerUserId={ownerUserId}
          entryId={entry.id}
          categoryKey={pickerFor}
          onClose={() => setPickerFor(null)}
        />
      )}
    </>
  );
}
